import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import "react-phone-input-2/lib/bootstrap.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import boyimg from "../../assets/images/boy.png";
import logowhite from "../../assets/images/logowhite.svg";
import arrowwblack from "../../assets/images/arrow-left.svg";
import { authService } from "services";
import { tabData } from "../../utils";
import Images from "assets/images";

const Login = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const userType = searchParams.get("userType");
  const [activeTab, setActiveTab] = useState(userType || "CLIENT");
  const [userDetails, setUserDetails] = useState({
    phone: "",
    countryCode: "+1",
  });
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const LIVE_SITE_URL = process.env.REACT_APP_LIVE_SITE_URL;
  
  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Enter") {
        handleSubmit();
      }
    };

    document.addEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [userDetails]);

  const handleSubmit = async () => {
    const payload = {
      ...userDetails,
      roleType: activeTab,
    };
    if (userDetails?.phone?.length < 1) {
      setError("Phone number is required!");
      return;
    }
    if (userDetails.phone.length !== 10) {
      setError("Please enter a valid 10-digit phone number");
      return;
    }
    try {
      const response = await authService.requestotp(payload);
      if (response?.data?.success) {
        localStorage.setItem("userData", JSON.stringify(payload));
        navigate(`/enter-otp?type=SIGN_IN`);
      }
      setError(response?.data?.message);
    } catch (err) {
      console.error(err?.response?.data?.message);
      setError(err?.response?.data?.message);
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSearchParams({ userType: tab });
  };

  const handleChange = (value) => {
    setError(null);
    const digitsOnly = value.replace(/\D/g, "");
    const phoneNumber = digitsOnly.startsWith("1")
      ? digitsOnly.slice(1)
      : digitsOnly;
    if (phoneNumber.length === 10) {
      setUserDetails({
        ...userDetails,
        phone: phoneNumber,
      });
    } else {
      setUserDetails({
        ...userDetails,
        phone: "",
      });
    }
  };
  return (
    <div className="container-fluid login-page p-0">
      <div className="row relative">
        <div className="col-lg-7 pr-0">
          <div className="right-login-side">
          <div className="nav-bar-container">
            <Link to={LIVE_SITE_URL} className="nav-bar">
              <img alt="" src={Images.arrowleft} className="me-2 py-1" />
              Home
            </Link>
          </div>

            <div className="outer-div-form">
              <div className="form-div">
                <img src={Images.drone} alt="logo" className="auth-drone mx-auto d-block" />
                <h4 className="text-center text-white form-hreading fw-bold">
                  Welcome back
                </h4>
                <Tabs
                  activeKey={activeTab}
                  onSelect={handleTabChange}
                  className="bg-transparent tab-outer border-0 mx-auto"
                >
                  {Object.keys(tabData).map((tabName, idx) => (
                    <Tab
                      eventKey={tabName}
                      title={tabData[tabName]}
                      key={`tab${idx}`}
                    >
                      <div className="tab-content-bg">
                      <div className="tab-content auth-tab-content px-lg-5 px-3">
                        <h2>Login Here</h2>
                        <p>Enter your registered mobile number to receive an verification code</p>
                        <form>
                          <div className="form-control-bg">
                            <PhoneInput
                              country="us"
                              onlyCountries={["us"]}
                              disableDropdown={true}
                              countryCodeEditable={false}
                              value={`${userDetails.countryCode}${userDetails.phone}`}
                              onChange={handleChange}
                              placeholder="Enter phone number"
                            />
                          </div>
                          {error && (
                              <div className="text-danger">{error}</div>
                            )}

                          <div className="text-center">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleSubmit}
                            >
                             Receive Verification code
                            </button>
                          </div>
                        </form>
                        <p className="text-center light-text  fw-bold register-bottom-text" >
                          Don’t have an account?{" "}
                          <Link
                            to={`/signup?userType=${activeTab}`}
                            className="text-decoration-none fw-bold text-blue"
                          >
                            Register Now
                          </Link>
                        </p>
                      </div>
                      </div>
                    </Tab>
                  ))}
                </Tabs>
              </div>
            </div>

            <div className="d-flex mt-md-0 mt-2 flex-md-row flex-column bottom-ft justify-content-between auth-bottom-links">
              <div className="mb-lg-0 mb-3 d-flex justify-content-md-start justify-content-center">
                <Link to={`${LIVE_SITE_URL}terms-conditions`}>Terms of Services</Link>
                <Link to={`${LIVE_SITE_URL}privacy-policy`}>Privacy Policy</Link>
              </div>
              <div className="mb-lg-0 mb-3 d-flex justify-content-md-end justify-content-center">
                <p>© 2023 SkyyTask. All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-5 pl-0 pr-0 pt-0">
          <div className="left-bg-form">
            <div className="logo-container w-100">
              <Link to={LIVE_SITE_URL} className="mx-auto mt-4 d-flex justify-content-center">
                <img alt="" src={logowhite} className="logo" />
              </Link>
            </div>
          </div>
        </div>


      </div>
    </div>
  );
};

export default Login;
